/**
 * Countdown Timer Web Component
 * High-precision countdown with looping or expiry handling
 */
class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.daysEl = this.querySelector('[data-days]');
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');
    this.expiredMsgEl = this.querySelector('[data-expired-message]');
    this.timerDisplayEl = this.querySelector('[data-timer-display]');

    this.endDateStr = this.getAttribute('data-end-date');
    this.expireBehavior = this.getAttribute('data-expire-behavior') || 'hide';
    this.loopHours = parseInt(this.getAttribute('data-loop-hours'), 10) || 24;

    this.targetTime = this.calculateTargetTime();
    this.interval = null;
  }

  connectedCallback() {
    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  calculateTargetTime() {
    if (!this.endDateStr) {
      // Default to end of current day if none provided
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59).getTime();
    }

    let target = new Date(this.endDateStr).getTime();
    if (isNaN(target) || target <= Date.now()) {
      if (this.expireBehavior === 'loop') {
        // Daily loop
        const now = new Date();
        const tomorrowMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0).getTime();
        return tomorrowMidnight;
      }
    }
    return target;
  }

  update() {
    const now = Date.now();
    let diff = this.targetTime - now;

    if (diff <= 0) {
      if (this.dataset.hideBar === 'true' || this.expireBehavior === 'hide_bar') {
        const bar = this.closest('.section-announcement-bar') ||
                    this.closest('[id*="announcement"]') ||
                    this.closest('.announcement-bar');
        if (bar) {
          bar.style.display = 'none';
        } else {
          this.style.display = 'none';
        }
        if (this.interval) clearInterval(this.interval);
        return;
      } else if (this.expireBehavior === 'loop') {
        this.targetTime = this.calculateTargetTime();
        diff = this.targetTime - now;
      } else if (this.expireBehavior === 'message' && this.dataset.showMessage === 'true') {
        if (this.timerDisplayEl) this.timerDisplayEl.style.display = 'none';
        if (this.expiredMsgEl) this.expiredMsgEl.style.display = 'block';
        if (this.interval) clearInterval(this.interval);
        return;
      } else {
        // hide
        this.style.display = 'none';
        if (this.interval) clearInterval(this.interval);
        return;
      }
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
    if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
    if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
    if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
